module.exports = __webpack_public_path__ + "static/media/bannerLogo.652ca0da.svg";